/*!
* @alife/cn-uni-api v2.10.0
* (c) Alibaba Group Holding Limited.
*
* @license ISC
* @build at 2023/8/21 10:19:44
*/
function navigateBack(params, context) {
    // 传递给上一个 WebViewController 的数据，数据会在 Active 事件中传递: https://h5.alibaba-inc.com/api/TaobaoClient-API.html#WebAppInterface-pop
    context === null || context === void 0 ? void 0 : context.WVCall('WebAppInterface.pop', params);
}

export { navigateBack as default };
